/** What the API knows about one GPU job for an object, from the worker's job registry. */
export type JobState = "queued" | "running" | "completed" | "failed" | "cancelled"

export type JobStatus = {
	state: JobState
	/** Which step of the object's pipeline this is — "render", "process", "prefetch", "preview"… */
	stage: string | null
	/** 0..1 while running; 1 once completed; null before the first report */
	progress: number | null
	/** Set when state is failed */
	error: string | null
	updated_at: number
}

/** States that mean the job is still going; anything else is a terminal record kept for a grace period. */
export const ACTIVE_JOB_STATES: ReadonlyArray<JobState> = ["queued", "running"]

/**
 * What a "start processing this object" call answers.
 *
 * `{ duplicate: true }` means a job for that object was already queued or running, so nothing new
 * was dispatched — the existing job is the one to follow. It is a 200, not an error: a second
 * trigger (a double click, a retry, a second tab) is a no-op rather than a failure. It replaced a
 * 423 that no caller ever handled.
 *
 * The API does not believe a "queued" record nothing has touched for its staleness window, so a
 * job that died before it started does not lock the object out until the record's TTL (GG-565).
 */
export type DispatchResult = { duplicate?: boolean } | void
